module.exports = __webpack_public_path__ + "assets/img/2-1.064d024d.jpg";